/* The inline "working" mark: Sami's zero at icon scale — the suite loader's
   glyph as a drop-in for a spinning lucide <Loader2>. className carries the
   size, margin and animate-spin utilities exactly as it did for the icon it
   replaces, and currentColor keeps button-text colours working — a white
   spinner on a violet button stays white. */
export default function SamiSpin({
  className,
  size,
  style,
}) {
  return (
    <svg
      viewBox="792 -3 203 203"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
      style={style}
      aria-hidden="true"
    >
      <path d="M892.898 0C838.622 0 794.627 44.1794 794.627 98.6843C794.627 153.189 838.622 197.353 892.898 197.353C947.175 197.353 991.169 153.174 991.169 98.6843C991.169 44.1948 947.175 0 892.898 0ZM892.898 132.923C874.096 132.923 858.803 117.566 858.803 98.6843C858.803 79.803 874.096 64.4303 892.898 64.4303C911.7 64.4303 926.993 79.803 926.993 98.6843C926.993 117.566 911.7 132.923 892.898 132.923ZM945.382 98.6843C945.382 69.5699 921.89 45.9645 892.898 45.9645C873.56 45.9645 856.657 56.4746 847.555 72.1089C853.087 44.718 877.268 24.0363 906.138 24.0363C939.084 24.0363 965.9 50.9656 965.9 84.0502C965.9 111.056 948.048 133.939 923.576 141.448C936.785 131.877 945.382 116.288 945.382 98.6843ZM892.898 178.887C848.858 178.887 813.016 142.91 813.016 98.6843C813.016 71.8935 826.163 48.1188 846.329 33.5462C834.883 47.1955 827.987 64.815 827.987 84.0502C827.987 127.399 862.971 162.53 906.138 162.53C928.02 162.53 947.788 153.512 961.977 138.955C948.109 162.822 922.335 178.887 892.898 178.887Z" />
    </svg>
  );
}
